import { KYMW1400Model } from '../kymw1400.model';
import { RegistGoodsModel } from '../vo/regist-goods.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品情報登録コマンド
 *
 * @export
 * @class RegistGoodsService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class RegistGoodsService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: KYMW1400Model = null;
  private vo: RegistGoodsModel = null;
  private successFunction: Function = null;
  private pCodeList: Array<string>;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistGoodsService
   */
  private getBody(): PlessRequest {
    const combinations = this.vo.goodsInfoVOList.map(goods => ({
      condition: {
        PCode: goods.pCode,
        PublishAmountLimitNum: goods.publishAmountLimitNum,
        OrderGoodsFlg: goods.orderGoodsFlg,
        ReceiptSOrderCode: goods.receiptSOrderCode,
        OrderNum6Digits: goods.orderNum6Digits,
        StartOrderCode: goods.startOrderCode,
        ItemCode: goods.itemCode
      }
    }));

    return new PlessRequest({
      regist: {
        Goods: {
          parameter: {
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType,
            CoopCode: this.vo.coopCode,
            PageNum: this.vo.pageNum,
            SectionID: this.vo.sectionID
          },
          condition: {
            KomaID: this.vo.komaID
          },
          combination: combinations
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1400Model} model モデルクラス
   * @param {RegistGoodsModel} vo パラメータ
   * @param {Array<string>} pCodeList Pコードリスト
   * @param {Function} successFunction 成功時後続処理
   * @memberof RegistGoodsService
   */
  execute(model: KYMW1400Model, vo: RegistGoodsModel, pCodeList: Array<string>, successFunction: Function) {
    this.model = model;
    this.vo = vo;
    this.pCodeList = pCodeList;
    this.successFunction = successFunction;
    this.send('KYMW14registGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistGoodsService
   */
  success(data: any) {
    // コマ情報追加
    this.model.selectedPage.updateKomaData(data);

    this.model.selectedPageViewHelper.page.clear();

    // ページ情報取得要求(/KYMW14/getPage.xml)をサーバに送信する。
    this.model.kymw1400Component.dispatchGetPageEvent();

    // 計画値集計表取得要求(/KYMW14/getPlanSummaryTable.xml)をサーバに送信する。
    this.model.kymw1400Component.dispatchGetPlanSummaryTableEvent();

    // 成功イベントが設定されている場合
    if (this.successFunction != null) {
      this.successFunction(this.pCodeList);
    }
  }
}
